module.exports = __webpack_public_path__ + "img/bg.26621039.png";